module.exports = __webpack_public_path__ + "static/media/Personal Amenities.bdba3599.svg";